"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOCKET_ENTRIES_UPDATED = exports.DOCKET_ENTRIES_FETCHED = exports.PACER_SEARCHED = void 0;
var PACER_SEARCHED = 'pacerSearched';
exports.PACER_SEARCHED = PACER_SEARCHED;
var DOCKET_ENTRIES_FETCHED = 'docketEntriesFetched';
exports.DOCKET_ENTRIES_FETCHED = DOCKET_ENTRIES_FETCHED;
var DOCKET_ENTRIES_UPDATED = 'docketEntriesUpdated';
exports.DOCKET_ENTRIES_UPDATED = DOCKET_ENTRIES_UPDATED;